export default __webpack_public_path__ + "static/media/confluence.0e202a3d.svg";